import React from "react";
import { Table } from "components";
import { useQueryParams } from "duck";
import { useGetOrganizationsReportQuery } from "requests";

const ReportsTable: React.FC = () => {
  const [{ pagination, filter }] = useQueryParams();

  const { data, loading } = useGetOrganizationsReportQuery({
    variables: {
      page: pagination?.page || 1,
      perPage: 15,
      dateFilter: filter?.date
    }
  });

  const reports =
    data?.reportOrganizationUserMedicalCaseCounters?.collection || [];

  return (
    <>
      {!reports.length && !loading ? null : (
        <Table
          data={reports}
          loading={loading}
          totalCount={
            data?.reportOrganizationUserMedicalCaseCounters?.paginationInfo
              ?.totalCount || 0
          }
          perPage={15}
        >
          <Table.Column dataKey="organizationName" label="Organization" />
          <Table.Column dataKey="userCount" label="Users" />
          <Table.Column dataKey="medicalCaseCount" label="Created Cases" />
        </Table>
      )}
    </>
  );
};

export default ReportsTable;
